"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var components_1 = require("components");
var react_redux_1 = require("react-redux");
var react_intl_1 = require("react-intl");
var utils_1 = require("../utils");
var Window = styled_components_1.default(components_1.MessageDialog)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmax-width: 731px;\n\tmax-height: 387px;\n\tmax-width: max(731px, 90%); /* stylelint-disable-line declaration-block-no-duplicate-properties */\n\tmax-height: min(387px, 80%); /* stylelint-disable-line declaration-block-no-duplicate-properties */\n"], ["\n\tmax-width: 731px;\n\tmax-height: 387px;\n\tmax-width: max(731px, 90%); /* stylelint-disable-line declaration-block-no-duplicate-properties */\n\tmax-height: min(387px, 80%); /* stylelint-disable-line declaration-block-no-duplicate-properties */\n"])));
var ContentDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 100%;\n\tpadding-top: 8px;\n\tpadding-bottom: 4px;\n\tflex-direction: column;\n\n\t@media ", " {\n\t\ttext-align: center;\n\t\tpadding-top: 4px;\n\t\tpadding-bottom: 4px;\n\t}\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 100%;\n\tpadding-top: 8px;\n\tpadding-bottom: 4px;\n\tflex-direction: column;\n\n\t@media ", " {\n\t\ttext-align: center;\n\t\tpadding-top: 4px;\n\t\tpadding-bottom: 4px;\n\t}\n"])), function (props) { return props.theme.breakpoints.S; });
var ButtonGroup = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tpadding: 10px 0 0 0;\n\n\tdisplay: flex;\n\n\talign-items: center;\n\tflex-grow: 1;\n\t\n\tflex-flow: row wrap;\n\tjustify-content: center;\n\n\t@media ", " {\n\t\tmargin: 0 -25px;\n\t}\n"], ["\n\tpadding: 10px 0 0 0;\n\n\tdisplay: flex;\n\n\talign-items: center;\n\tflex-grow: 1;\n\t\n\tflex-flow: row wrap;\n\tjustify-content: center;\n\n\t@media ", " {\n\t\tmargin: 0 -25px;\n\t}\n"])), function (props) { return props.theme.breakpoints.S; });
var ButtonMargin = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.buttonMargin; });
var Message = styled_components_1.default(components_1.Paragraph)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tfont-size: 22px;\n\t@media ", " {\n\t\tfont-size: 16px;\n\t}\n"], ["\n\tfont-size: 22px;\n\t@media ", " {\n\t\tfont-size: 16px;\n\t}\n"])), function (props) { return props.theme.breakpoints.S; });
var GenericDialog = /** @class */ (function (_super) {
    __extends(GenericDialog, _super);
    function GenericDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.close = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.getButton = function (buttInfo, index) {
            return (react_1.default.createElement(ButtonMargin, { key: index }, index === 0 ?
                react_1.default.createElement(components_1.PrimaryLargeButton, { text: buttInfo.label, onClick: buttInfo.onClick, automationId: buttInfo.automationId })
                :
                    react_1.default.createElement(components_1.SecondaryLargeButton, { text: buttInfo.label, onClick: buttInfo.onClick, automationId: buttInfo.automationId })));
        };
        _this.getLinkButton = function (buttInfo, index) {
            return (react_1.default.createElement(ButtonMargin, { key: index },
                react_1.default.createElement(components_1.LinkButton, { text: buttInfo.label, onClick: buttInfo.onClick, automationId: buttInfo.automationId })));
        };
        return _this;
    }
    GenericDialog.prototype.render = function () {
        var _this = this;
        var s = function (id, defaultStr, params) {
            return utils_1.formatMessage(_this.props.intl, { id: id, defaultMessage: defaultStr ? defaultStr : id }, params ? params : {});
        };
        var close = s("general.close", "Close");
        var error = this.props.title || s("closeDialog.error", "Oops!");
        var buttons = this.props.buttons;
        if (!buttons) {
            buttons = [
                {
                    label: s("errors.ok", "OK"),
                    onClick: function () { return _this.close; },
                    automationId: "ok"
                }
            ];
        }
        return (react_1.default.createElement(Window, { title: error, onClose: this.props.onClose, closeTooltip: close, hideClose: !this.props.showClose },
            react_1.default.createElement(ContentDiv, null,
                react_1.default.createElement(Message, { text: this.props.info }),
                buttons &&
                    react_1.default.createElement(ButtonGroup, null, buttons.map(function (butt, index) {
                        return _this.getButton(butt, index);
                    })),
                this.props.linkButtons &&
                    react_1.default.createElement(ButtonGroup, null, this.props.linkButtons.map(function (butt, index) {
                        return _this.getLinkButton(butt, index);
                    })))));
    };
    return GenericDialog;
}(react_1.Component));
var MapStoreToProps = function (store /*, ownProps:any*/) {
    return {};
};
exports.default = react_redux_1.connect(MapStoreToProps)(styled_components_1.withTheme(react_intl_1.injectIntl(GenericDialog)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=GenericDialog.js.map